(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("react"), require("react-dom"));
	else if(typeof define === 'function' && define.amd)
		define("HCS", ["react", "react-dom"], factory);
	else if(typeof exports === 'object')
		exports["HCS"] = factory(require("react"), require("react-dom"));
	else
		root["HCS"] = factory(root["React"], root["ReactDOM"]);
})(window, (__WEBPACK_EXTERNAL_MODULE_react__, __WEBPACK_EXTERNAL_MODULE_react_dom__) => {
return 